import React from 'react';
import styled from 'styled-components';
import { Alert, Color, Icon } from '@bb/elements-web';
import { BORDER_RADIUS, DENIED_STATUSES } from '../../constants';

type DenyReasonBannerProps = {
  reason: string;
  status: (typeof DENIED_STATUSES)[number];
};
const bannerContentMap = {
  cancel: 'Your showing request is cancelled because ',
  deny: 'Your showing request has been declined because ',
};

const DenyReasonBanner: React.FC<DenyReasonBannerProps> = ({
  reason,
  status,
}) => (
  <StyledAlert
    type="error"
    data-cy="showingDetails-denyReason-banner"
    showIcon
    icon={<Icon icon="closeCircleOutlined" color="danger" size={16} />}
    message={`${bannerContentMap[status]}"${reason}"`}
  />
);
export default DenyReasonBanner;

const StyledAlert = styled(Alert)`
  && {
    padding: 8px;
    margin-bottom: 24px;
    background-color: #fff1f0;
    border: 1px solid #ffa39e;
    border-radius: ${BORDER_RADIUS}px;
    color: ${Color.BLACK};
    align-items: flex-start;
    .anticon {
      line-height: 22px;
      padding-right: 6px;
      padding-top: 2px;
    }
  }
`;
